/**
 * Ghana phone helpers for fast feedback and display. The server normalizes for identity
 * (backend `normalizeDestination`: +233 followed by 2 or 5 and eight digits).
 */

function compact(value: string) {
  return value.trim().replace(/[\s().-]/g, '');
}

function toNational(value: string): string | null {
  const c = compact(value);
  const international = c.startsWith('+233')
    ? c.slice(1)
    : c.startsWith('233')
      ? c
      : c.startsWith('0')
        ? `233${c.slice(1)}`
        : '';
  if (!/^233[25]\d{8}$/.test(international)) return null;
  return `0${international.slice(3)}`;
}

export function isValidGhanaPhone(value: string): boolean {
  return toNational(value) !== null;
}

/** `024 400 0000` for any accepted input; returns the input unchanged when it is not valid. */
export function formatGhanaPhone(value: string | null | undefined): string {
  if (!value) return '';
  const national = toNational(value);
  if (!national) return value;
  return `${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
}

/** International digits for wa.me links (`233244000000`), or null. */
export function toWhatsAppNumber(value: string | null | undefined): string | null {
  if (!value) return null;
  const national = toNational(value);
  return national ? `233${national.slice(1)}` : null;
}

export const PHONE_INCOMPLETE =
  'That number looks incomplete. Ghana numbers are 10 digits and start with 0.';
